import React, { Fragment, useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const PBTableMenuItem = (props) => {
  const { params, editHandle, deleteHandle, AddPaymentModel, showPaymentList } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const RowOptions = () => {
    return (
      <>
        {params.row.vendorId && (
          <>
            <MenuItem onClick={() => editHandle(params.row.vendorBillId, handleClose())}>Edit</MenuItem>
            <MenuItem onClick={() => deleteHandle(params.row.vendorBillId, handleClose())}>Delete</MenuItem>
            <MenuItem
              onClick={() =>
                AddPaymentModel(
                  {
                    vendorBillId: params.row.vendorBillId,
                    dueAmount: params.row.dueAmount,
                    totalAmount: params.row.totalAmount,
                    paidAmount: params.row.paidAmount
                  },
                  handleClose()
                )
              }
            >
              Add Payment
            </MenuItem>
            <MenuItem onClick={() => showPaymentList(params.row.vendorBillId, handleClose())}>
              show Payment List
            </MenuItem>
          </>
        )}
      </>
    );
  };

  return (
    <Fragment>
      <div>
        <IconButton id="basic-button" aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
          {/* {params.row.bankId && ( */}
          {/* <MenuItem onClick={() => editHandle(params.row.bankId)}>
                Edit
              </MenuItem>
              <MenuItem onClick={() => showHandle(params.row.bankId)}>
                View
              </MenuItem>
              <MenuItem onClick={() => StatementRedirect(params.row.bankId)}>
                Statement
              </MenuItem> */}
          {/* )} */}
          <RowOptions />
        </Menu>
      </div>
    </Fragment>
  );
};

export default PBTableMenuItem;
